"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Responsive = void 0;

var _react = _interopRequireDefault(require("react"));

var _utilResponsive = require("./utilResponsive");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _getWindowDimension = (0, _utilResponsive.getWindowDimension)(),
    width = _getWindowDimension.width,
    height = _getWindowDimension.height;

var Responsive =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Responsive, _React$PureComponent);

  function Responsive() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Responsive);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Responsive)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      width: width,
      height: height
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          displayIn = _this$props.displayIn;
      var _this$state = _this.state,
          width = _this$state.width,
          height = _this$state.height;
      var dispInArr = displayIn.map(function (val) {
        return val.toLowerCase();
      });

      var shouldRenderChildren = _this.shouldRender(dispInArr, width, height);

      return _react["default"].createElement(_react["default"].Fragment, null, shouldRenderChildren ? children : null);
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      var _getWindowDimension2 = (0, _utilResponsive.getWindowDimension)(),
          width = _getWindowDimension2.width,
          height = _getWindowDimension2.height;

      _this.setState({
        width: width,
        height: height
      });
    });

    _defineProperty(_assertThisInitialized(_this), "shouldRender", function (display, width, height) {
      if (display.indexOf("laptop") !== -1 && width > height && width >= _utilResponsive.IdDeviceBreakpointsByWidth.laptop_min) {
        //  always landscape
        return true;
      }

      if (display.indexOf("tablet") !== -1) {
        if (width <= _utilResponsive.IdDeviceBreakpointsByWidth.tablet_max && width >= _utilResponsive.IdDeviceBreakpointsByWidth.tablet_min) {
          return true;
        } //  Cater iPad pro portrait (ONLY)


        if (width === 1024 && height === 1366) {
          return true;
        }
      } // For mobile regardless of orientation


      if (display.indexOf("mobile") !== -1 && width <= _utilResponsive.IdDeviceBreakpointsByWidth.mobile_max) {
        return true;
      }

      if (display.indexOf("mobileportrait") !== -1 && width <= _utilResponsive.IdDeviceBreakpointsByWidth.mobile_max && height >= _utilResponsive.IdMobileHeight.mobileLandscape_max) {
        return true;
      }

      return !!(display.indexOf("mobilelandscape") !== -1 && width <= _utilResponsive.IdDeviceBreakpointsByWidth.mobile_max && height <= _utilResponsive.IdMobileHeight.mobileLandscape_min);
    });

    return _this;
  }

  _createClass(Responsive, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleResize, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize, false);
    }
  }]);

  return Responsive;
}(_react["default"].PureComponent);

exports.Responsive = Responsive;